export const UPDATE_DATA = 'scenes/components/PolicyForm/update_data'

export const UPDATE_EXTRA_DATA_FIELD = 'scenes/components/PolicyForm/update_extra_data_field'
export const DELETE_EXTRA_DATA_FIELD = 'scenes/components/PolicyForm/delete_extra_data_field'
export const ADD_EXTRA_DATA = 'scenes/components/PolicyForm/add_extra_data'

export const RESET_STATE = 'scenes/components/PolicyForm/reset_state'



// WEBPACK FOOTER //
// ./src/components/PolicyForm/constants.js